import React, { useEffect,useState } from 'react'
import "../../../CSS/ContabilidadesStyle.css"
import { FaArrowLeftLong, FaCalendarCheck } from "react-icons/fa6";
import { useNavigate } from "react-router";
import { MdEdit, MdDelete } from "react-icons/md";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import moment from 'moment-timezone';
import 'moment/locale/es';
import { getPermission } from '../../../Conexiones/Conexion';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';

function ContabilidadProyectos() {
  const uri = 'accounts/projects/';
  /* Ingresos Start*/
  function Ingresos() {
    return(
      <div className="table-responsive table-cont">
        <table className="table table-hover text-uppercase" >
          <thead>
            <tr>
              <th>PROYECTO</th>
              <th>CANTIDAD</th>
              <th>FORMA</th>
              <th>FACTURADA</th>
              <th>NOTA</th>
              <th>FECHA</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
              {ingresos.map(ip =>{
                return(
                  <tr key={ip.id}>
                    <td>{getPro(ip.proyecto)}</td>
                    <td>{'$ '+formato(ip.cantidad)}</td>
                    <td>{ip.forma}</td>
                    <td>{ip.status}</td>
                    <td>{ip.nota}</td>
                    <td>{ip.fecha}</td>
                    <td>
                      <div className='acciones'>
                        <div className='editar'><MdEdit className='icon' title="EDITAR" onClick={() => openEditModal(ip.id,ip.proyecto,ip.cantidad,ip.forma,ip.fecha,ip.status,ip.nota)}/></div>
                        <div className='eliminar'><MdDelete className='icon' title="ELIMINAR" onClick={() => modalDelete(ip.id)}/></div>
                      </div>

                    </td>
                  </tr>
                )
              })
              }
            </tbody>
        </table>
      </div>
    )
  }
  /* Ingresos Finish*/

  /* Egresos Start*/
  function Egresos() {
    return(
      <div className="table-responsive table-cont">
        <table className="table table-hover text-uppercase" >
          <thead>
            <tr>
              <th>PROYECTO</th>
              <th>CANTIDAD</th>
              <th>FORMA</th>
              <th>STATUS</th>
              <th>NOTA</th>
              <th>FECHA</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
              {egresos.map(ep =>{
                return(
                  <tr key={ep.id}>
                    <td>{getPro(ep.proyecto)}</td>
                    <td>{'$ '+formato(ep.cantidad)}</td>
                    <td>{ep.forma}</td>
                    <td>{ep.status}</td>
                    <td>{ep.nota}</td>
                    <td>{ep.fecha}</td>
                    <td>
                    <div className='acciones'>
                        <div className='editar'><MdEdit className='icon' title="EDITAR" onClick={() => openEditModal(ep.id,ep.proyecto,ep.cantidad,ep.forma,ep.fecha,ep.status,ep.nota)}/></div>
                        <div className='eliminar'><MdDelete className='icon' title="ELIMINAR" onClick={() => modalDelete(ep.id)} /></div>
                      </div>
                    </td>
                  </tr>
                )
              })
              }
            </tbody>
        </table>
      </div>
    )
  }
  /* Egresos Finish*/

  /* Modal agregar */
  function ModalAgregar(props) {
    const [selected, setSelected] = useState(0);
    const [saving, setSaving] = useState(false);
    const [proyecto, setProyecto] = useState('')
    const [cantidad, setCantidad] = useState('');
    const [forma, setForma] = useState('');
    const [fecha, setFecha] = useState('');
    const [status, setStatus] = useState('');
    const [nota, setNota] = useState('');
    const select = (value) =>{
      setCantidad('');
      setForma('');
      setFecha('');
      setStatus('');
      setNota('');
      setProyecto('');
      const select = parseInt(value);
      setSelected(select);
    }
    const save = async () => {
      setSaving(true);
      if(selected === 1 || selected === 2){
        if(cantidad.trim().length === 0 || forma.trim().length === 0 || fecha.trim().length === 0 || status.trim().length === 0 || proyecto.trim().length === 0){
          warningToast('¡ERROR!',"CAMPOS VACÍOS");
        }else{
          await saveAccounting(selected, proyecto, cantidad, forma, fecha, status, nota);
        }
      }else{
        warningToast('¡ERROR!',"POR FAVOR SELECCIONE UN TIPO");
      }
      setSaving(false);
    }
    return(
      <Modal {...props} id="modal-agregar-account">
        <Modal.Header className=' btncolor'>
          <Modal.Title>AGREGAR</Modal.Title>
          <CloseButton onClick={props.onHide} style={{backgroundColor:"white"}} />
        </Modal.Header>
          <div className="divO">
              <label className="obligatorio">Obligatorio *</label>  
          </div>
        <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
          <div className="mb-3 ">
            <label htmlFor="exampleFormControlInput12" className="form-label">SELECCIONE EL TIPO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
            <select className="form-control text-uppercase" required id='tipo'
              onChange={e => select(e.target.value) }   >
              <option key={0} value={0}>--Seleccione una opción--</option>
              <option key={1} value={1}>INGRESO</option>
              <option key={2} value={2}>EGRESO</option>                              
            </select>
          </div>
          {selected === 1 || selected === 2?
            <div style={{height:'45vh', overflowY:'scroll', }}>
              <div className="mb-3 ">
                <label htmlFor="exampleFormControlInput12" className="form-label">TIPO DE PROYECTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                <select className="form-control text-uppercase" required onChange={e => setProyecto(e.target.value) }   >
                  <option >--Seleccione una opción--</option>
                  {
                    proyectos.map(p => {
                      return(
                          <option key={p.id} value={p.id}>{p.proyecto}</option>
                      )
                    })
                  }                                
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">CANTIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                <input type="text" className="form-control"  id="name" required 
                onChange={e => setCantidad(e.target.value) } value={cantidad} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">FORMA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                <input type="text" className="form-control"  id="name" required 
                onChange={e => setForma(e.target.value) } value={forma} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput6" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                <input type="date" className="form-control" id="exampleFormControlInput6" required
                onChange={e => setFecha(e.target.value) } value={fecha} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput9" className="form-label">FACTURADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                <div onChange={e => setStatus(e.target.value)} >
                  <div className="form-check" >
                    <input className="form-check-input" type="radio" value="si" name="seguro" id="flexRadioDefault10" required/>
                    <label className="form-check-label" htmlFor="flexRadioDefault10">
                      SI
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" value="no" name="seguro" id="flexRadioDefault11" />
                    <label className="form-check-label" htmlFor="flexRadioDefault11">
                      NO
                    </label>
                  </div>                             
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput6" className="form-label">NOTA</label>
                <input type="text" className="form-control" id="exampleFormControlInput6" 
                onChange={e => setNota(e.target.value) } value={nota} />
              </div>
            </div>:null
          }
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" className="btn btn-secondary" onClick={props.onHide} >CANCELAR</Button>
          <Button type="submit" className="btn btn-light btncolor" onClick={()=>save()} disabled={saving} >GUARDAR CAMBIOS</Button>
        </Modal.Footer>
      </Modal> 
    )
  }
  /* Modal agregar */

   /* Modal editar */
  const [id,setId] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [forma, setForma] = useState('');
  const [fecha, setFecha] = useState('');
  const [status, setStatus] = useState('');
  const [nota, setNota] = useState('');
  const [proyecto, setProyecto] = useState('')

  const openEditModal = (ui,project,amount,form,date,state,note) =>{
    const arrF = date.split('-'); 
    const id = ui;
    const cantidad = amount;
    const forma = form;
    const fecha = arrF[2]+'-'+arrF[1]+'-'+arrF[0]
    const status = state==="FACTURADA"?'si':'no';
    const nota = note;
    const proyecto = project;
    setId(id);
    setProyecto(proyecto)
    setCantidad(cantidad);
    setForma(forma);
    setFecha(fecha);
    setStatus(status);
    setNota(nota);
    setModalEditShow(true);
   }
  const cancel = () =>{
    setId('')
    setCantidad('');
    setForma('');
    setFecha('');
    setStatus('');
    setNota('');
    setProyecto('')
    setModalEditShow(false);
  }
  function ModalEditar(props) {
    const idME = props.id;
    const [saving, setSaving] = useState(false);
    const [proyectoME, setProyectoME] = useState(props.proyecto);
    const [cantidadME,setCantidadME] = useState(props.cantidad);
    const [formaME,setFormaME] = useState(props.forma);
    const [fechaME,setFechaME] = useState(props.fecha);
    const [statusME,setStatusME] = useState(props.status);
    const [notaME,setNotaME] = useState(props.nota);    
    const save = async () => {
      setSaving(true);
        if(cantidadME.trim().length === 0 || formaME.trim().length === 0 || fechaME.trim().length === 0 || statusME.trim().length === 0 || proyectoME === 0){
          warningToast('¡ERROR!',"CAMPOS VACÍOS");
        }else{
          await updateAccounting(idME,proyectoME,cantidadME,formaME,fechaME,statusME,notaME);
        }
      setSaving(false);
    }
    return(
      <Modal {...props} id="modal-editar-account">
        <Modal.Header className=' btncolor'>
          <Modal.Title>EDITAR</Modal.Title>
          <CloseButton onClick={cancel} style={{backgroundColor:"white"}} />
        </Modal.Header>
          <div className="divO">
              <label className="obligatorio">Obligatorio *</label>  
          </div>
        <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
          <div className="mb-3 ">
            <label htmlFor="exampleFormControlInput12" className="form-label">TIPO: {tab===1?'INGRESO':'EGRESO'}</label>
          </div>
          <div style={{height:'50vh', overflowY:'scroll', }}>
            <div className="mb-3 ">
              <label htmlFor="exampleFormControlInput12" className="form-label">TIPO DE PROYECTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
              <select className="form-control text-uppercase" defaultValue={proyectoME} required onChange={e => setProyectoME(e.target.value) }   >
                <option >--Seleccione una opción--</option>
                {
                  proyectos.map(p => {
                    return(
                        <option key={p.id} value={p.id} >{p.proyecto}</option>
                    )
                  })
                }                                
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput1" className="form-label">CANTIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
              <input type="text" className="form-control"  id="name" required 
              onChange={e => setCantidadME(e.target.value) } value={cantidadME} />
            </div>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput1" className="form-label">FORMA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
              <input type="text" className="form-control"  id="name" required 
              onChange={e => setFormaME(e.target.value) } value={formaME} />
            </div>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput6" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
              <input type="date" className="form-control" id="exampleFormControlInput6" required
              onChange={e => setFechaME(e.target.value) } value={fechaME} />
            </div>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput9" className="form-label">FACTURADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
              <div onChange={e => setStatusME(e.target.value)} >
                <div className="form-check" >
                  <input className="form-check-input" type="radio" value="si" name="seguro" defaultChecked={statusME==='si'?true:false} id="flexRadioDefault10" required/>
                  <label className="form-check-label" htmlFor="flexRadioDefault10">
                    SI
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" value="no" name="seguro" defaultChecked={statusME==='no'?true:false} id="flexRadioDefault11" />
                  <label className="form-check-label" htmlFor="flexRadioDefault11">
                    NO
                  </label>
                </div>                             
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput6" className="form-label">NOTA</label>
              <input type="text" className="form-control" id="exampleFormControlInput6" 
              onChange={e => setNotaME(e.target.value) } value={notaME} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" className="btn btn-secondary" onClick={cancel} >CANCELAR</Button>
          <Button type="submit" className="btn btn-light btncolor" onClick={save} disabled={saving} >GUARDAR CAMBIOS</Button>
        </Modal.Footer>
      </Modal> 
    )
  }
  /* Modal editar */

  const navigate = useNavigate()
  const [tab, setTab] = useState(1);
  const [mes, setMes] = useState(moment().tz('America/Mexico_City').format('YYYY-MM'));
  const [monthModal, setMonthModal] = useState(false);
  const [selMonth, setSelMonth] = useState('');
  const [ingresos, setIngresos] = useState([]);
  const [egresos, setEgresos] = useState([]);
  const [totalIng, setTotalIng] = useState("");
  const [totalEgr, setTotalEgr] = useState("");
  const [utilidad, setUtilidad] = useState("");
  const [proyectos, setProyectos] = useState([]);

  function formato(numero){
    var num = Number.parseFloat(numero).toFixed(2)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }

  function getPro(idp) {
    const id = idp;
    const proy = proyectos.filter((item) => item.id === id);
    const name = proy[0].proyecto;
    return name;
  }

  useEffect(()=>{
    const month = moment().tz('America/Mexico_City').format('YYYY-MM');
    setMes(month);
    setSelMonth(month);
  },[setMes]);
  
  useEffect(()=>{
    const month = moment().tz('America/Mexico_City').format('YYYY-MM');
    const getAccounts = async (ms) =>{
      const usuario = JSON.parse(sessionStorage.getItem('user')) 
      const idUsuario = usuario[0].idUsuario
      const permiso = await getPermission(idUsuario,21);
      if(permiso){
        const endpoint = uri + ms;
        const res = await getApi(endpoint);
        if(res.status === 1){
          if(res.data.length !== undefined){
            setIngresos(res.data[0].ingresos);
            setEgresos(res.data[0].egresos);
            setTotalIng(res.data[0].totalIng)
            setTotalEgr(res.data[0].totalEgr);
            setUtilidad(res.data[0].utilidad);
            setProyectos(res.data[0].proyectos);
          }else{
            errorMessage(res.data.message);
          }
        }else if(res.status === 210){
          navigate('/');
        }else{
          errorMessage(res.message);
        }
      }else{
        navigate('/inicio')
      }
    }
    getAccounts(month);
    
  },[navigate]);

  const getAccounts = async (ms) =>{
    const endpoint = uri + ms;
    const res = await getApi(endpoint);
    if(res.status === 1){
      if(res.data.length !== undefined){
        setIngresos(res.data[0].ingresos);
        setEgresos(res.data[0].egresos);
        setTotalIng(res.data[0].totalIng)
        setTotalEgr(res.data[0].totalEgr);
        setUtilidad(res.data[0].utilidad);
        setProyectos(res.data[0].proyectos);
      }else{
        errorMessage(res.data.message);
      }
    }else if(res.status === 210){
      navigate('/');
    }else{
      errorMessage(res.message);
    }
  }

  function getMonth(month) {
    moment.locale('es-es');
    const mes = moment(month).format('MMMM');
    const year = moment(month).format('YYYY');
    const date = mes + " " + year;
    return date;
  }
  const handleMonthSave = async () =>{
    setMes(selMonth);
    handleCloseMM();
    setTab(1);
    await getAccounts(selMonth);
  }
  const handleMonthClose = () =>{
    setSelMonth(mes);
    handleCloseMM();
  }

  const handleCloseMM = () => setMonthModal(false);
  const handleShowMM = () => setMonthModal(true);

  const backCont = () =>{
    navigate('/inicio/Contabilidad')
  }

  //Modal Agregar
  const [modalShow, setModalShow] = React.useState(false);
  const [modalEditShow, setModalEditShow] = React.useState(false);

  async function saveAccounting(type,project, account, form, date, state,note) {
    const tipo = type; 
    const cantidad = account;
    const forma = form;
    const fecha = date;
    const status = state;
    const nota = note;
    const proyecto = project;
    const data = {tipo:tipo,proyecto:proyecto, cantidad:cantidad, forma:forma, fecha:fecha, status:status, nota: nota};
    const endpoint = uri;
    const res = await postApi(endpoint,data);
    if(res.status === 1){
      if(res.data.status===1){
        setMes(fecha.substring(0,7));
        setSelMonth(fecha.substring(0,7));
        getAccounts(fecha);
        setModalShow(false);
        setTab(tipo);
        successToast("AGREGADO");
      }else{
        errorToast("¡ERROR!",res.data.message);
      }
    }else if(res.status === 210){
      navigate('/');
    }else{
      errorMessage(res.message);
    }
  }

  async function updateAccounting(ui,project,account,form,date,state,note) {
    const id = ui;
    const proyecto = project;
    const cantidad = account;
    const forma = form;
    const fecha = date;
    const status = state;
    const nota = note;
    const data = {id:id,proyecto:proyecto,tipo:tab, cantidad:cantidad, forma:forma, fecha:fecha, status:status, nota: nota};
    const endpoint = uri;
    const res = await putApi(endpoint,data);
    if(res.status === 1){
      if(res.data.status === 1){
        getAccounts(fecha);
        setModalEditShow(false);
        setMes(fecha.substring(0,7));
        setSelMonth(fecha.substring(0,7));
        successToast("EDITADO");
      }else{
        errorToast("¡ERROR!",res.data.message);
      }
    }else if(res.status === 210){
      navigate('/');
    }else{
      errorMessage(res.message);
    }
  }
  
  const modalDelete = (id) => {
    warningModal('¿QUIERES ELIMINAR ESTE REGISTRO?')
    .then(async (result) => {
      if (result.isConfirmed) {
        const endpoint = uri + id + '/' + tab;
        const res = await deleteApi(endpoint);
        if(res.status === 1){
          if(res.data.status === 1){
            getAccounts(mes);
            successToast("ELIMINADO");
          }else{
              errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
          navigate('/');
        }else{
          errorMessage(res.message);
        }
      }
    })
  }

  return (
    <div className='contabilidades-container'>
      <ModalAgregar show={modalShow} onHide={() => setModalShow(false)} />
      <ModalEditar show={modalEditShow} onHide={() => setModalEditShow(false)} id={id} proyecto={proyecto} cantidad={cantidad} forma={forma} fecha={fecha} status={status} nota={nota} />
      <div className='contabilidades-header'>
        <div className='fab'><FaArrowLeftLong className='arrow' onClick={backCont} title='REGRESAR'/></div>
        <label>PROYECTOS</label>
      </div>
      <div className='contabilidades-body'>
        <div className='body-header'>
          <div className='bh-left'><button className='btn btn-add'  onClick={() => setModalShow(true)} >+ Agregar</button></div>
          <div className='bh-middle'><label>{getMonth(mes).toUpperCase()}</label></div>
          <div className='bh-right'><button className='btn btn-add'  onClick={() => handleShowMM(true)} ><FaCalendarCheck />&nbsp;MES</button></div>
        </div>
        <div className='body-container'>
          <div className='bc-header'>
            <nav className='navtabs'>
              <div className="nav nav-tabs tabs-cont" id="nav-tab" role="tablist">
                <button className={tab === 1 ?"nav-link active":"nav-link"} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected={tab === 1 ?"true":"false"} onClick={() =>setTab(1)}>Ingresos</button>
                <button className={tab === 2 ?"nav-link active":"nav-link"} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected={tab === 2 ?"true":"false"} onClick={() =>setTab(2)}>Egresos</button>
              </div>
            </nav>
          </div>
          <div className='bc-container'>
              {tab === 2 ? 
                <Egresos />:
                <Ingresos />
              }
          </div>
        </div>
      </div>
      <div className='contabilidades-footer'>
        <div className='cf-ingreso'>
          <label>INGRESOS: {totalIng}</label>
        </div>
        <div className='cf-egreso'>
          <label>EGRESOS: {totalEgr}</label>
        </div>
        <div className='cf-utilidad'>
          <label>UTILIDAD: {utilidad}</label>
        </div>
      </div>
      {/* SELECT MONTH */}
      <Modal show={monthModal} onHide={handleCloseMM}>
        <Modal.Header closeButton>
          <Modal.Title>SELECCIONAR MES</Modal.Title>
        </Modal.Header>
        <Modal.Body><input type="month" className="form-control" onChange={e => setSelMonth(e.target.value) } value={selMonth}/></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleMonthClose}>
            CANCELAR
          </Button>
          <Button variant="primary" onClick={handleMonthSave}>
            ACEPTAR
          </Button>
        </Modal.Footer>
      </Modal>
      {/* MODAL EDITAR */}
    </div>
  )
}

export default ContabilidadProyectos